export default {
  "Excel Editor": "محرر Excel",
  "Excel file downloaded successfully": "تم تنزيل ملف Excel بنجاح",
  "Expires {date}": "تنتهي في {date}",
  "Explore the collection": "استكشف التشكيلة",
  "Explore the menu": "استكشف القائمة",
  "Export Database": "تصدير قاعدة البيانات",
  "Export:": "التصدير:",
  "Exporting...": "جارٍ التصدير...",
  "Extras": "إضافات",
  "FIND YOUR FLAVOR": "اكتشف نكهتك",
  "Facebook": "فيسبوك",
  "Failed to acknowledge order": "تعذر استلام الطلب",
  "Failed to assign plan": "تعذر تعيين الخطة",
  "Failed to block date": "تعذر حظر التاريخ",
  "Failed to cancel subscription": "تعذر إلغاء الاشتراك",
  "Failed to change operating mode": "تعذر تغيير وضع التشغيل",
  "Failed to confirm": "تعذر التأكيد",
  "Failed to confirm payment": "تعذر تأكيد الدفع",
  "Failed to copy link": "تعذر نسخ الرابط",
  "Failed to create backup": "تعذر إنشاء النسخة الاحتياطية",
  "Failed to create booking": "تعذر إنشاء الحجز",
  "Failed to create plan": "تعذر إنشاء الخطة",
  "Failed to delete backup": "تعذر حذف النسخة الاحتياطية",
  "Failed to delete category": "تعذر حذف التصنيف",
  "Failed to delete employee": "تعذر حذف الموظف",
  "Failed to delete menu item": "تعذر حذف العنصر",
  "Failed to delete recipe": "تعذر حذف الوصفة",
  "Failed to delete recipe ingredient": "تعذر حذف مكوّن الوصفة",
  "Failed to delete service": "تعذر حذف الخدمة",
  "Failed to delete stock item": "تعذر حذف عنصر المخزون",
  "Failed to delete table": "تعذر حذف الطاولة",
  "Failed to disconnect": "تعذر قطع الاتصال",
  "Failed to download Excel file": "تعذر تنزيل ملف Excel",
  "Failed to export report": "تعذر تصدير التقرير",
  "Failed to generate QR code": "تعذر إنشاء رمز QR",
  "Failed to generate checkout link": "تعذر إنشاء رابط الدفع",
  "Failed to load availability": "تعذر تحميل التوفر",
  "Failed to load backups": "تعذر تحميل النسخ الاحتياطية",
  "Failed to load billing info": "تعذر تحميل معلومات الفوترة",
  "Failed to load bookings": "تعذر تحميل الحجوزات",
  "Failed to load cash reconciliation": "تعذر تحميل تسوية النقد",
  "Failed to load daily sales": "تعذر تحميل المبيعات اليومية",
  "Failed to load dashboard": "تعذر تحميل لوحة التحكم",
  "Failed to load dashboard data": "تعذر تحميل بيانات لوحة التحكم",
  "Failed to load employees": "تعذر تحميل الموظفين",
  "Failed to load inventory data": "تعذر تحميل بيانات المخزون",
  "Failed to load inventory history": "تعذر تحميل سجل المخزون",
  "Failed to load inventory usage": "تعذر تحميل استهلاك المخزون",
  "Failed to load menu": "تعذر تحميل القائمة",
  "Failed to load menu data": "تعذر تحميل بيانات القائمة",
  "Failed to load orders": "تعذر تحميل الطلبات",
  "Failed to load payment methods": "تعذر تحميل طرق الدفع",
  "Failed to load product stock": "تعذر تحميل مخزون المنتجات",
  "Failed to load products": "تعذر تحميل المنتجات",
  "Failed to load recipes": "تعذر تحميل الوصفات",
  "Failed to load restaurant details": "تعذر تحميل تفاصيل المطعم",
  "Failed to load restaurants": "تعذر تحميل المطاعم",
  "Failed to load sales range": "تعذر تحميل مبيعات الفترة",
  "Failed to load services": "تعذر تحميل الخدمات",
  "Failed to load store overview": "تعذر تحميل نظرة عامة على المتجر",
  "Failed to load table turnover": "تعذر تحميل معدل دوران الطاولات",
  "Failed to load tables": "تعذر تحميل الطاولات",
  "Failed to load top items": "تعذر تحميل العناصر الأكثر مبيعًا",
  "Failed to load variants": "تعذر تحميل الخيارات",
  "Failed to mark order as completed": "تعذر تعليم الطلب كمكتمل",
  "Failed to print QR code": "تعذرت طباعة رمز QR",
  "Failed to record stock movement": "تعذر تسجيل حركة المخزون",
  "Failed to remove photo": "تعذر حذف الصورة",
  "Failed to restore backup": "تعذرت استعادة النسخة الاحتياطية",
  "Failed to save category": "تعذر حفظ التصنيف",
  "Failed to save employee": "تعذر حفظ الموظف",
  "Failed to save hours": "تعذر حفظ ساعات العمل",
  "Failed to save restaurant": "تعذر حفظ المطعم",
  "Failed to save service": "تعذر حفظ الخدمة",
  "Failed to save settings": "تعذر حفظ الإعدادات",
  "Failed to save table": "تعذر حفظ الطاولة",
  "Failed to search images": "تعذر البحث عن الصور",
  "Failed to submit order": "تعذر إرسال الطلب",
  "Failed to unblock date": "تعذر إلغاء حظر التاريخ",
  "Failed to update booking": "تعذر تحديث الحجز",
  "Failed to update order": "تعذر تحديث الطلب",
  "Failed to update order status": "تعذر تحديث حالة الطلب",
  "Failed to update payment status": "تعذر تحديث حالة الدفع",
  "Failed to update price": "تعذر تحديث السعر",
  "Failed to update stock": "تعذر تحديث المخزون",
  "Failed to upload image": "تعذر رفع الصورة",
  "Failed to upload photos": "تعذر رفع الصور",
  "Failed to {action} restaurant": "تعذر {action} المطعم",
  "Favicon URL": "رابط أيقونة الموقع",
  "Featured": "مميز",
  "Fee": "الرسوم",
  "File size must be less than {v0}MB": "يجب أن يكون حجم الملف أقل من {v0} ميغابايت",
  "Fill in your name, username, and password": "أدخل اسمك واسم المستخدم وكلمة المرور",
  "Filter by Code/Customer/PIN": "تصفية حسب الرمز/العميل/PIN",
  "Filter reservations": "تصفية الحجوزات",
  "Financial Breakdown": "التفاصيل المالية",
  "Find a service…": "ابحث عن خدمة…",
  "Find my order": "ابحث عن طلبي",
  "Find your keys in the Stripe Dashboard under": "ستجد مفاتيحك في لوحة تحكم Stripe ضمن",
  "Find your service": "ابحث عن خدمتك",
  "Find your service, choose a time, and leave the rest to us.": "ابحث عن خدمتك، اختر وقتًا، واترك الباقي علينا.",
  "Follow us": "تابعنا",
  "Food item": "صنف طعام",
  "Footer Text": "نص التذييل",
  "For WhatsApp, enter the number with the country code. Customers tap it to start a chat.": "لواتساب، أدخل الرقم مع رمز الدولة. ينقر العملاء عليه لبدء المحادثة.",
  "For assistance:": "للمساعدة:",
  "For feedback:": "للملاحظات:",
  "Free": "مجاني",
  "Free item": "عنصر مجاني",
  "Free trial": "تجربة مجانية",
  "Fresh cards with dietary tag badges": "بطاقات منعشة مع وسوم غذائية",
  "Fresh finds, bright colors, happy prices.": "اكتشافات جديدة، ألوان زاهية، وأسعار مفرحة.",
  "Fresh, balanced dishes made with wholesome ingredients": "أطباق طازجة ومتوازنة بمكونات صحية",
  "From the QR menu on the table to the ticket in the kitchen.": "من قائمة QR على الطاولة إلى تذكرة الطلب في المطبخ.",
  "From:": "من:",
  "Fulfilment": "طريقة الاستلام",
  "Full Name *": "الاسم الكامل *",
  "Full delivery address": "عنوان التوصيل الكامل",
  "Full name": "الاسم الكامل",
  "Full street address": "العنوان الكامل",
  "Full-bleed hero, one featured piece, big photos in a magazine layout": "واجهة بعرض كامل، قطعة مميزة واحدة، وصور كبيرة بتصميم مجلة",
  "Full-width list • Serif fonts • Luxury feel": "قائمة بعرض كامل • خطوط كلاسيكية • طابع فاخر",
  "Full-width photo banner for every section, heavy slab type": "صورة عريضة لكل قسم، وخطوط عريضة ثقيلة",
  "Fully booked": "محجوز بالكامل",
  "GOOD FOOD. GOOD COMPANY.": "طعام طيب. صحبة طيبة.",
  "Gallery photos": "صور المعرض",
  "General": "عام",
  "General Settings": "الإعدادات العامة",
  "Generate QR codes and manage tables": "إنشاء رموز QR وإدارة الطاولات",
  "Generate checkout link": "إنشاء رابط الدفع",
  "Generating QR code...": "جارٍ إنشاء رمز QR...",
  "Get paid your way": "استلم أموالك بطريقتك",
  "Get started": "ابدأ الآن",
  "Get started by adding your first table": "ابدأ بإضافة أول طاولة",
  "Get started by adding your first variant.": "ابدأ بإضافة أول خيار.",
  "Get started by creating your first recipe": "ابدأ بإنشاء أول وصفة",
  "Get started by creating your first restaurant": "ابدأ بإنشاء أول مطعم",
  "Get your own website, take orders and payments, manage stock and bookings, and grow with loyalty and WhatsApp - in Arabic and English.": "احصل على موقعك الخاص، واستقبل الطلبات والمدفوعات، وأدر المخزون والحجوزات، ونمِّ نشاطك بالولاء وواتساب - بالعربية والإنجليزية.",
  "Give your store a name": "اختر اسمًا لمتجرك",
  "Gluten-free": "خالٍ من الغلوتين",
  "Go Home": "الذهاب إلى الرئيسية",
  "Go to products": "الذهاب إلى المنتجات",
  "Good company.": "صحبة طيبة.",
  "Gram": "غرام",
  "Guest": "ضيف",
  "Guests": "الضيوف",
  "Handwritten chalk menu in a wooden frame, round photos": "قائمة مكتوبة بالطباشير في إطار خشبي مع صور دائرية",
  "Have a look around and add something you like.": "تجوّل في المتجر وأضف ما يعجبك.",
  "Header Text": "نص الترويسة",
  "Headline": "العنوان الرئيسي",
  "Healthy - Diet & Wellness": "صحي - حمية وعافية",
  "Heavy": "ثقيل",
  "Hello,": "مرحبًا،",
  "Hero image": "صورة الواجهة",
  "Hide password": "إخفاء كلمة المرور",
  "Hide secret key": "إخفاء المفتاح السري",
  "High Stock": "مخزون مرتفع",
  "High-protein": "غني بالبروتين",
  "Hire Date": "تاريخ التوظيف",
  "History": "السجل",
  "Holidays or days off - no bookings will be available on these dates": "العطل وأيام الإجازة - لن تتوفر حجوزات في هذه التواريخ",
  "Hotel": "فندق",
  "Hour": "الساعة",
  "Hourly Sales": "المبيعات بالساعة",
  "Hover": "عند التمرير",
  "How can we help?": "كيف يمكننا مساعدتك؟",
  "How do customers pay?": "كيف يدفع العملاء؟",
  "ITEMS": "العناصر",
  "Image": "الصورة",
  "Image size must be less than 5MB": "يجب أن يكون حجم الصورة أقل من 5 ميغابايت",
  "Image upload failed": "فشل رفع الصورة",
  "Image uploaded - remember to save": "تم رفع الصورة - لا تنسَ الحفظ",
  "Image uploaded successfully": "تم رفع الصورة بنجاح",
  "Import": "استيراد",
  "Import Excel / Google Sheet": "استيراد Excel / Google Sheet",
  "Import failed. Try again.": "فشل الاستيراد. حاول مرة أخرى.",
  "Import {v0} {noun}": "استيراد {v0} {noun}",
  "In progress": "قيد التنفيذ",
  "In stock": "متوفر",
  "In-store / Pickup": "في المتجر / استلام",
  "Inactive": "غير نشط",
  "Increase quantity": "زيادة الكمية",
  "Ingredient": "المكوّن",
  "Ingredients": "المكونات",
  "Ingredients *": "المكونات *",
  "Initialize Database": "تهيئة قاعدة البيانات",
  "Initialize:": "التهيئة:",
  "Initializing...": "جارٍ التهيئة...",
  "Instagram": "إنستغرام",
  "Instructions for customers (optional)": "تعليمات للعملاء (اختياري)",
  "Instructions shown to customers": "التعليمات المعروضة للعملاء",
  "Inventory": "المخزون",
  "Inventory Management": "إدارة المخزون",
  "Inventory Status": "حالة المخزون",
  "Inventory Usage": "استهلاك المخزون",
  "Inventory that keeps up": "مخزون يواكب مبيعاتك",
  "Inventory usage loaded successfully": "تم تحميل استهلاك المخزون بنجاح",
  "Invoice history": "سجل الفواتير",
  "Invoices": "الفواتير",
  "Item": "العنصر",
  "Item Image": "صورة العنصر",
  "Item Name": "اسم العنصر",
  "Item Name *": "اسم العنصر *",
  "Item removed": "تم حذف العنصر",
  "Item updated": "تم تحديث العنصر",
  "Item {v0}": "تم {v0} العنصر",
  "Items": "العناصر",
  "Items in your cart": "العناصر في سلتك",
  "Items subtotal": "مجموع العناصر",
  "Items to Prepare:": "العناصر المطلوب تحضيرها:",
  "JPG, PNG, WEBP or PDF · max 8 MB": "JPG أو PNG أو WEBP أو PDF · حد أقصى 8 ميغابايت",
  "JSON theme packages up to 1 MB": "حزم ثيم JSON حتى 1 ميغابايت",
  "John Doe": "محمد أحمد",
  "Join us.": "انضم إلينا.",
  "Just for you.": "من أجلك فقط.",
  "KB": "كيلوبايت",
  "KITCHEN ORDER": "طلب المطبخ",
  "Keto": "كيتو",
  "Kilogram": "كيلوغرام",
  "Kitchen": "المطبخ",
  "Kitchen Display": "شاشة المطبخ",
  "Kitchen Display System": "نظام شاشة المطبخ",
  "Kitchen order printed successfully": "تمت طباعة طلب المطبخ بنجاح",
  "Language": "اللغة",
  "Last Updated": "آخر تحديث",
  "Late (16-30min)": "متأخر (16-30 دقيقة)",
  "Layout": "التخطيط",
  "Layout Settings": "إعدادات التخطيط",
  "Leave blank to keep current": "اتركه فارغًا للإبقاء على الحالي",
  "Light": "خفيف",
  "Limited runs. When it is gone, it is gone.": "كميات محدودة. عندما تنفد، تنفد.",
  "Link menu items with their ingredients to enable automatic inventory deduction": "اربط عناصر القائمة بمكوناتها لتفعيل الخصم التلقائي من المخزون",
  "LinkedIn": "لينكدإن",
  "Liter": "لتر",
  "Little things that make you smile.": "أشياء صغيرة تجعلك تبتسم.",
  "Live availability calendar": "تقويم توفر مباشر",
  "Live in three steps": "انطلق في ثلاث خطوات",
  "Live preview": "معاينة مباشرة",
  "Live updates": "تحديثات مباشرة",
  "Load sheet": "تحميل الجدول",
  "Loading activity logs...": "جارٍ تحميل سجل النشاط...",
  "Loading backups...": "جارٍ تحميل النسخ الاحتياطية...",
  "Loading bill data...": "جارٍ تحميل بيانات الفاتورة...",
  "Loading billing info...": "جارٍ تحميل معلومات الفوترة...",
  "Loading billing...": "جارٍ تحميل الفوترة...",
  "Loading dashboard...": "جارٍ تحميل لوحة التحكم...",
  "Loading employees...": "جارٍ تحميل الموظفين...",
  "Loading history...": "جارٍ تحميل السجل...",
  "Loading inventory...": "جارٍ تحميل المخزون...",
  "Loading kitchen orders...": "جارٍ تحميل طلبات المطبخ...",
  "Loading menu data...": "جارٍ تحميل بيانات القائمة...",
  "Loading menu...": "جارٍ تحميل القائمة...",
  "Loading options...": "جارٍ تحميل الخيارات...",
  "Loading orders...": "جارٍ تحميل الطلبات...",
  "Loading payment methods...": "جارٍ تحميل طرق الدفع...",
  "Loading product...": "جارٍ تحميل المنتج...",
  "Loading products...": "جارٍ تحميل المنتجات...",
  "Loading receipt…": "جارٍ تحميل الإيصال…",
  "Loading recipes...": "جارٍ تحميل الوصفات...",
  "Loading reservations…": "جارٍ تحميل الحجوزات…",
  "Loading restaurants...": "جارٍ تحميل المطاعم...",
  "Loading services...": "جارٍ تحميل الخدمات...",
  "Loading settings...": "جارٍ تحميل الإعدادات...",
  "Loading tables...": "جارٍ تحميل الطاولات...",
  "Loading variants...": "جارٍ تحميل الخيارات...",
  "Loading your order…": "جارٍ تحميل طلبك…",
  "Loading your store overview...": "جارٍ تحميل نظرة عامة على متجرك...",
  "Loading your website...": "جارٍ تحميل موقعك...",
  "Loading your workspace…": "جارٍ تحميل مساحة عملك…",
  "Loading...": "جارٍ التحميل...",
  "Local Mode": "الوضع المحلي",
  "Local Mode:": "الوضع المحلي:",
  "Location": "الموقع",
  "Log in": "تسجيل الدخول",
  "Logged out successfully": "تم تسجيل الخروج بنجاح",
  "Login": "تسجيل الدخول",
  "Logo Preview": "معاينة الشعار",
  "Logo URL": "رابط الشعار",
  "Logout": "تسجيل الخروج",
  "Look up": "بحث",
  "Lookup failed": "فشل البحث",
  "Low Stock": "مخزون منخفض",
  "Low Stock Alert": "تنبيه انخفاض المخزون",
  "Low stock": "مخزون منخفض",
  "Low stock alert at": "تنبيه انخفاض المخزون عند",
  "Low stock alert for {name}": "تنبيه انخفاض المخزون لـ {name}",
  "Low stock email alerts": "تنبيهات البريد عند انخفاض المخزون",
  "Low-carb": "قليل الكربوهيدرات",
  "Loyalty": "الولاء",
  "Loyalty Program": "برنامج الولاء",
  "Loyalty customer?": "عميل برنامج الولاء؟",
  "Loyalty member created": "تم إنشاء عضو الولاء",
  "Loyalty program enabled": "تم تفعيل برنامج الولاء",
  "Loyalty settings saved": "تم حفظ إعدادات الولاء",
  "Luxury - Fine Dining": "فاخر - مطاعم راقية",
  "MAD (check Stripe support first)": "MAD (تحقق من دعم Stripe أولًا)",
  "MAKE TIME FOR WHAT MATTERS": "خصّص وقتًا لما يهمك",
  "MB": "ميغابايت",
  "Made for the way you work": "مصمم لطريقة عملك",
  "Made for your table": "صُنع لطاولتك",
  "Main navigation": "التنقل الرئيسي",
  "Make another reservation": "إجراء حجز آخر",
  "Make it yours.": "اجعله خاصًا بك.",
  "Manage Menu": "إدارة القائمة",
  "Manage Products": "إدارة المنتجات",
  "Manage Tables": "إدارة الطاولات",
  "Manage all your restaurants from one central dashboard": "أدر جميع مطاعمك من لوحة تحكم مركزية واحدة",
  "Manage categories, items, and modifiers": "إدارة التصنيفات والعناصر والإضافات",
  "Manage categories, items, variants, and modifiers": "إدارة التصنيفات والعناصر والخيارات والإضافات",
  "Manage customer orders and status": "إدارة طلبات العملاء وحالاتها",
  "Manage payment method": "إدارة طريقة الدفع",
  "Manage restaurant tables and QR codes": "إدارة طاولات المطعم ورموز QR",
  "Manage stock items and inventory levels": "إدارة عناصر المخزون ومستوياته",
  "Manage stock items, recipes, and inventory levels": "إدارة عناصر المخزون والوصفات ومستوياته"
}
